import React from 'react';
import { oneOf, string } from 'prop-types';
import classNames from 'classnames';
import { useIntl } from '../../util/reactIntl';
import { NamedLink } from '../../components';

import css from './LinkedLogo.module.css';

const LOGO_GREEN = '#1c4c31';

const TradMarketFullLogo = ({ className, ...props }) => {
  const logoClasses = classNames(css.logo, css.logoDesktop, className);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1403.2 213"
      width={216}
      className={logoClasses}
      fill={LOGO_GREEN}
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        d="M1375 176.95c-12.7 0-21.9-2.8-27.6-8.5s-8.6-14.8-8.6-27.2v-45.1h-19.4v-21.3h19.4v-26.7h28.6v26.7h32.8v21.3h-32.8v44.2c0 5 1.2 8.7 3.6 11s6.3 3.6 11.5 3.6c5.5 0 11.1-.9 16.9-2.7l3.8 20.5c-9 2.8-18.4 4.2-28.2 4.2ZM701 175.05V37.95h35.7l48.8 104.1 48.6-104.1H869v137.1h-28.6v-93.5l-43.7 93.5h-23.6l-43.8-92.7v92.7H701zM1006.9 175.05V74.85h28v16.3c9.9-12 22-18 36.3-18 3.3 0 7 .3 11.1 1l-3.3 23.8c-3.8-.8-7.6-1.2-11.1-1.2-9.6 0-17.5 2.7-23.8 8.1-5.8 5.1-8.6 11-8.6 17.7v52.5h-28.6ZM1091.6 175.05V37.95h28.6v72l46.5-35.1h37.1l-43 32.3 47.4 68h-32.4l-36.1-52.4-19.4 14.4v38h-28.7v-.1zM923.1 177.75c-13.2 0-23.3-2.7-30.3-8s-10.6-12.9-10.6-22.8c0-11 4.6-19.2 13.8-24.6s23.7-8.3 43.6-8.8l24.6-.6v-3.8c0-5.6-2-10-6.1-13s-9.9-4.5-17.5-4.5c-14.5 0-23.1 4.1-25.9 12.3l-25.9-2.5c2-10.1 7.5-17.6 16.2-22.5s21-7.3 36.6-7.3c33.4 0 50.1 13.2 50.1 39.6v63.8h-26.5v-13.6c-5.9 5.6-12.2 9.8-18.9 12.4-6.8 2.6-14.5 3.9-23.2 3.9Zm7.7-20c5.4 0 10.3-.7 14.8-2s8.3-3.3 11.3-5.9c4.9-3.8 7.3-8.7 7.3-14.6v-5.4l-24 .6c-10.4.3-18 1.6-22.8 3.9-4.8 2.3-7.2 5.9-7.2 10.7 0 4.1 1.8 7.2 5.3 9.4s8.6 3.3 15.3 3.3Z"
        fillRule="evenodd"
      />
      <path
        d="M1260.3 178.15c-18.2 0-32.3-4.5-42.3-13.6s-15.1-21.8-15.1-38.2c0-10.5 2.3-19.9 7-28.1 4.7-8.3 11.4-14.7 20.2-19.4 8.8-4.7 19-7 30.8-7 17.9 0 31.8 4.5 41.6 13.5s14.7 21.7 14.7 37.9v8.6H1230c.1 5 1.5 9.4 4.1 13.2s6.3 6.8 10.9 9 10.1 3.3 16.2 3.3c15 0 24.3-4.5 27.8-13.6h26.7c-2.7 11.6-8.6 20.3-17.8 25.9-9 5.7-21.6 8.5-37.6 8.5Zm-29.5-63.8h59.7c-.3-7-3-12.5-8.3-16.4s-12.5-5.9-21.9-5.9c-7.9 0-14.7 2.1-20.3 6.3-5.5 4.3-8.6 9.6-9.2 16ZM138.2 175.05V74.85h28v16.3c9.9-12 22-18 36.3-18 3.3 0 7 .3 11.1 1l-3.3 23.8c-3.8-.8-7.6-1.2-11.1-1.2-9.6 0-17.5 2.7-23.8 8.1-5.8 5.1-8.6 11-8.6 17.7v52.5h-28.6ZM251.7 177.75c-13.2 0-23.3-2.7-30.3-8s-10.6-12.9-10.6-22.8c0-11 4.6-19.2 13.8-24.6s23.7-8.3 43.6-8.8l24.6-.6v-3.8c0-5.6-2-10-6.1-13s-9.9-4.5-17.5-4.5c-14.5 0-23.1 4.1-25.9 12.3l-25.9-2.5c2-10.1 7.5-17.6 16.2-22.5 8.8-4.9 21-7.3 36.6-7.3 33.4 0 50.1 13.2 50.1 39.6v63.8h-26.5v-13.6c-5.9 5.6-12.2 9.8-18.9 12.4s-14.5 3.9-23.2 3.9Zm7.7-20c5.4 0 10.3-.7 14.8-2s8.3-3.3 11.3-5.9c4.9-3.8 7.3-8.7 7.3-14.6v-5.4l-24 .6c-10.4.3-18 1.6-22.8 3.9-4.8 2.4-7.2 5.9-7.2 10.7 0 4.1 1.8 7.2 5.3 9.4s8.6 3.3 15.3 3.3ZM379.8 178.15c-9.6 0-18.1-2.1-25.5-6.3s-13.2-10.3-17.5-18.1-6.3-17.1-6.3-27.7 2.1-19.8 6.3-27.9 10.3-14.5 18.1-19.2c7.9-4.7 17.1-7 27.7-7 16.1 0 28.7 5.4 37.8 16.3v-50.3H449v137.1h-28v-15.7c-4.5 6.1-10.3 10.8-17.4 14-7 3.2-14.9 4.8-23.8 4.8Zm10-22.1c4.5 0 8.7-.8 12.7-2.3s7.4-3.8 10.4-6.7c2.6-2.6 4.5-5.5 5.9-8.8s2-6.8 2-10.4v-5.2c0-4-.7-7.7-2.1-11.3s-3.4-6.7-6-9.4c-5.1-5.4-12.4-8.1-21.9-8.1-10 0-17.6 2.7-22.8 8-5.2 5.3-7.9 13.2-7.9 23.5 0 9.7 2.6 17.3 7.9 22.7 5.2 5.3 12.5 8 21.8 8ZM53.7 175.05V63.45H0v-25.5h138.2v25.5H84.5v111.6H53.7z"
        fillRule="evenodd"
      />
      <path d="m527.65 110.4-10.55 10.55-14.45-14.45 14.45-14.45 36.92 36.93 17.08-17.08-54-54-48.6 48.6 48.6 48.6 27.62-27.62-17.07-17.08zM526.4 48.6l27.63 27.62 17.07-17.07-10.55-10.55L575 34.15l14.45 14.45-36.93 36.93 17.08 17.07 54-54L575 0l-48.6 48.6zM578.9 153.85l10.55 10.55L575 178.85l-14.45-14.45 36.93-36.93-17.08-17.07-54 54L575 213l48.6-48.6-27.63-27.62-17.07 17.07zM622.35 102.6l10.55-10.55 14.45 14.45-14.45 14.45-36.93-36.93-17.07 17.08 54 54 48.6-48.6-48.6-48.6-27.62 27.63 17.07 17.07z" />
    </svg>
  );
};

const TradMarketLogo = ({ className, layout, ...props }) => {
  const logoClasses = classNames(className, layout === 'mobile' ? css.logoMobile : null);
  return <TradMarketFullLogo className={logoClasses} {...props} />;
};

/** The logo, linking home. `alt` names the link (the logo itself is a picture). */
const LinkedLogo = props => {
  const {
    className,
    rootClassName,
    logoClassName,
    logoImageClassName,
    layout,
    alt,
    ...rest
  } = props;
  const intl = useIntl();
  const classes = classNames(rootClassName || css.root, className);
  const label = alt || intl.formatMessage({ id: 'LinkedLogo.homeLink' });
  return (
    <NamedLink className={classes} name="LandingPage" aria-label={label} {...rest}>
      <TradMarketLogo layout={layout} className={logoClassName} />
    </NamedLink>
  );
};

LinkedLogo.defaultProps = {
  className: null,
  rootClassName: null,
  logoClassName: null,
  logoImageClassName: null,
  layout: 'desktop',
  alt: null,
};

LinkedLogo.propTypes = {
  className: string,
  rootClassName: string,
  logoClassName: string,
  logoImageClassName: string,
  layout: oneOf(['desktop', 'mobile']),
  alt: string,
};

export default LinkedLogo;
